// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.js-components-css-BlockFileModal-module__modalContent{width:320px}`, "",{"version":3,"sources":["webpack://./js/components/css/BlockFileModal.module.scss"],"names":[],"mappings":"AAAA,uDACI,WAAA","sourcesContent":[".modalContent {\n    width: 320px;\n}\n"],"sourceRoot":""}]);
// Exports
export var modalContent = `js-components-css-BlockFileModal-module__modalContent`;
export default ___CSS_LOADER_EXPORT___;
